import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import { getPropsBlocker } from '../../utils';
import { transitionDurationInSec } from '../../constants';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
import { popperArrow, popperArrowPlacement } from '../../utils/popper';
import { zIndex } from '../../system';
var propertyList = {
  align: true,
  hidden: true,
  error: true,
  small: true,
  zIndex: true
};

var getDynamicStyle = function getDynamicStyle(element, _ref) {
  var error = _ref.error,
      theme = _ref.theme;
  var Tooltip = theme.componentOverrides.Tooltip;

  if (error) {
    return Tooltip[element].error;
  }

  return Tooltip[element].normal;
};

var getRootStyle = function getRootStyle(props) {
  return getDynamicStyle('Root', props);
};

var getArrowStyle = function getArrowStyle(props) {
  return getDynamicStyle('Arrow', props);
};

var sizeStyle = function sizeStyle(_ref2) {
  var small = _ref2.small,
      theme = _ref2.theme;
  var Tooltip = theme.componentOverrides.Tooltip;

  if (small) {
    return Tooltip.Root.small;
  }

  return '';
};

export var TooltipRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    text-align: left;\n    box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.12);\n    transition: opacity ", "s ease;\n    pointer-events: none;\n\n    ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), transitionDurationInSec, popperArrowPlacement('Tooltip-Arrow'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.componentOverrides.Tooltip.Root.base;
}, zIndex, getRootStyle, sizeStyle, getComponentOverride('Tooltip'));
export var TooltipArrow = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n"])), popperArrow, function (_ref4) {
  var theme = _ref4.theme;
  return theme.componentOverrides.Tooltip.Arrow.base;
}, getArrowStyle);